import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { transportMovements } from '../TransportMovements';

type OptionsType = {
  enabled: boolean;
};

export const useTransportMovements = (
  requestedDate: string,
  options?: OptionsType,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.transportMovements, requestedDate],
    queryFn: async () =>
      (
        await transportMovements.getTransportMovements({
          RequestedDate: requestedDate,
        })
      ).data,
    enabled: options?.enabled,
  });

export const useSearchTransportMovements = (
  search: string,
  options?: OptionsType,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.transportMovementsSearch, search],
    queryFn: async () =>
      (await transportMovements.searchTransportMovements({ Search: search }))
        .data,
    enabled: options?.enabled,
  });

export const useLoadDetails = (loadId: number, options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.transportLoadDetails, loadId],
    queryFn: async () => (await transportMovements.getloadDetails(loadId)).data,
    enabled: options?.enabled,
  });

export const useMovementLogs = (loadId: number, options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.transportLoadLogs, loadId],
    queryFn: async () =>
      (await transportMovements.getMovementsLogs(loadId)).data,
    enabled: options?.enabled,
  });
